(function (sgadwc, $, undefined) {

	sgadwc.setupFlip = tick => {

		// loop over localization object and call setConstant method
		for (let key in sgadwcDiscountBannerSettings.localization) {
			if (!sgadwcDiscountBannerSettings.localization.hasOwnProperty(key)) {
				continue;
			}
			Tick.options.setConstant(key, sgadwcDiscountBannerSettings.localization[key]);
		}

		// get timer offset (if not found, set to today)
		// var offset = new Date( localStorage.getItem('countdown-offset') || new Date() );
		let offset = new Date();

		// store the offset (not really necessary but saves some if statements)
		localStorage.setItem('countdown-offset', offset);

		// time in hours the timer will run down
		// let timeDuration = Tick.helper.duration(2, 'hours');
		// let timeDuration = Tick.helper.duration(120, 'minutes');
		// let timeDuration = Tick.helper.duration(120 * 60, 'seconds');
		// let timeDuration = Tick.helper.duration(3, 'seconds');
		// let timeDuration = Tick.helper.duration(30 * 60, 'seconds');
		// let timeDuration = Tick.helper.duration(100 * 60 + 5, 'seconds');
		let timeDuration = Tick.helper.duration(sgadwcDiscountBannerSettings.expiryInSeconds, 'seconds');

		// add 24 hours to get final deadline
		const deadline = new Date(offset.setMilliseconds(offset.getMilliseconds() + timeDuration));

		// create counter
		const counter = Tick.count.down(deadline, {format: ['m', 's']});

		// update tick with the counter value
		counter.onupdate = function (value) {
			tick.value = value;
		};

		counter.onended = function () {

			// take the flipperSettings.expiryText, split it into an array with 2 characters per element and save it under expiryTextArray
			const expiryTextArray = sgadwcDiscountBannerSettings.localization.expiryText.split(/(?=(?:..)*$)/);

			// set the tick value to the expiryTextArray
			tick.value = [expiryTextArray[0], expiryTextArray[1]];

			// show message, uncomment the next line
			// document.querySelector('.tick-onended-message').style.display = '';
		};
	}

	// using JavaScript set the style for the element with id sgadwc-countdown to background-color: #e6f2ff; and border: 1px solid border: 1px solid #b3d9ff;

	sgadwc.transformColor = inputColor => {
		// Parse the input color into its RGB components
		const r1 = parseInt(inputColor.substring(1, 3), 16);
		const g1 = parseInt(inputColor.substring(3, 5), 16);
		const b1 = parseInt(inputColor.substring(5, 7), 16);

		// Calculate the target RGB components based on the given transformation
		const r2 = 179 + Math.round((r1 - 230) * 0.5);
		const g2 = 217 + Math.round((g1 - 242) * 0.5);
		const b2 = 255;

		// Convert the target RGB components into a hex color code
		const hex = "#" + ((1 << 24) + (r2 << 16) + (g2 << 8) + b2).toString(16).slice(1);

		// Return the target hex color code
		return hex;
	}

	sgadwc.calculateBoxShadow = hexColor => {
		// Remove '#' symbol if it exists
		hexColor = hexColor.replace('#', '');

		// Convert to RGBA with 50% opacity
		const red       = parseInt(hexColor.substring(0, 2), 16);
		const green     = parseInt(hexColor.substring(2, 4), 16);
		const blue      = parseInt(hexColor.substring(4, 6), 16);
		const alpha     = 0.5; // 50% opacity
		const rgbaColor = 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')';

		// Calculate box shadow values
		const horizontalOffset = '0px';
		const verticalOffset   = '0px';
		const blurRadius       = '10px';
		const spreadRadius     = '0px';

		// Combine values to create box shadow CSS property
		const boxShadow = horizontalOffset + ' ' + verticalOffset + ' ' + blurRadius + ' ' + spreadRadius + ' ' + rgbaColor;

		// Return box shadow CSS property
		// console.log(boxShadow)
		return boxShadow;
	}

}(window.sgadwc = window.sgadwc || {}, jQuery))


// use jQuery to determine when the document is ready and then call the setupFlip method
// jQuery(document).on("ready", function ($) {
//     let highlightColor = null;
//
//     highlightColor = sgadwcDiscountBannerSettings.highlightColor;
//     // highlightColor = '#e6f2ff';
//     // highlightColor = '#007cc2';
//     // highlightColor = '#01458e';
//     // highlightColor = '#cce5f3';
//     // highlightColor = '#fcbe8b';
//     // highlightColor = '#ffe58d';
//     // highlightColor = '#000000';
//     // highlightColor = '#ffffff';
//
//     // continue if highlightColor is set
//     if (highlightColor) {
//         document.getElementById('sgadwc-countdown').style.backgroundColor = highlightColor;
//         // document.getElementById('sgadwc-countdown').style.border = '1px solid ' + transformColor(highlightColor);
//     }
//
//     document.getElementById('sgadwc-countdown').style.boxShadow = '0 0 10px 1px rgba(0, 0, 0, 0.5)';
// })

/**
 * Event listener for 'show_variation' event on '.single_variation_wrap' elements.
 * This event is triggered when a variation is selected in a variable product.
 * The listener performs an AJAX request to get the discount banner HTML and adds it to the '#sgadwc-banner-container' element.
 *
 * source: https://stackoverflow.com/a/27849208/4688612
 */

jQuery(".single_variation_wrap").on('show_variation',  (event, variation) => {

	const sgadwcBannerContainer = jQuery('#sgadwc-banner-container');
	const sgadwcBadgeContainer = jQuery('#sgadwc-badge-container');

	// Only run if there is an #sgadwc-banner-container element
	// if (sgadwcBannerContainer.length === 0) {
	// 	return;
	// }

	// Remove everything within #sgadwc-banner-container
	sgadwcBannerContainer.empty();
	sgadwcBadgeContainer.empty();

	// Set all .new-badge elements to display: none
	jQuery('.new-badge').each(function () {
		jQuery(this).hide();
	});

	jQuery.ajax({
		url:     ajax_var.url,
		data:    {
			action:       'sgadwc_get_discount_elements',
			variation_id: variation.variation_id,
		},
		type:    'post',
		success: function (response) {

			if(response?.data?.banner) {
				sgadwcBannerContainer.html(response.data.banner);

				// Check if Tick is loaded and if so, parse the DOM
				if (typeof Tick !== 'undefined' && typeof Tick.DOM.parse === 'function') {
					// console.log("Tick.DOM.parse(document.body)")
					Tick.DOM.parse(document.body);
				}

				// sgadwcBannerContainer.show();
			}

			if(response?.data?.badge) {

				jQuery(".woocommerce-product-gallery").append(response.data.badge);

				repositionBadges();
			}
		},
		error:   function (response) {
			console.log('Error: ' + response);
		}
	});
});


/**
 * Places the discount badge at the bottom of the product image if the badge is set to be at the bottom.
 *
 * A calculation is needed to determine the height of the product image and then set the top position of the badge.
 */
jQuery(document).ready(function () {
	repositionBadges();
});

const repositionBadges = () => {
	jQuery('.new-badge').each(function () {

		if (jQuery(this).hasClass('bottom')) {

			let imageHeight = 0;

			if (jQuery(this).parent().parent().hasClass('woocommerce-product-gallery__wrapper')) {
				imageHeight = jQuery(this).parent().parent().height();
			} else if (jQuery(this).prevAll('.flex-viewport').first().length) {
				console.log('flex-viewport')
				imageHeight = jQuery(this).prevAll('.flex-viewport').first().height();
			} else {
				imageHeight = jQuery(this).parent().nextAll('a').first().children().first().height();
			}

			let top = imageHeight - jQuery(this).height() - 5;
			jQuery(this).css('top', top + 'px');
		}

		jQuery(this).parent().show()

		jQuery(this).show()
	});
}
